/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveCatalogCheckerViewProps } from './eve-catalog-checker';

export default (props: IEveCatalogCheckerViewProps) => {
    return <div className='row'></div>;
};
